import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: ShareCodeState = {
  shareCode: window.localStorage.getItem('qvue_share_code') || null,
};

const getters: GetterTree<ShareCodeState, RootState> = {};

const actions: ActionTree<ShareCodeState, RootState> = {
  validate(_, shareCode) {
    return http.v1.sc.validate({
      params: {
        share_code: shareCode,
      },
    });
  },
};

const mutations: MutationTree<ShareCodeState> = {
  SET_SHARE_CODE(state, payload) {
    state.shareCode = payload;
    if (state.shareCode != null) {
      localStorage.setItem('qvue_share_code', state.shareCode);
    }
  },
  RESET_SHARE_CODE(state) {
    state.shareCode = null;
    localStorage.removeItem('qvue_share_code');
  },
};

const shareCode: Module<ShareCodeState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default shareCode;
